// extracted by mini-css-extract-plugin
export default {"wrapper":"l5-z"};